export function isNativeApp() {
  return ['ios', 'android'].includes(process.env.CORDOVA_PLATFORM || '');
}

export function getNativePlatform() {
  return process.env.CORDOVA_PLATFORM;
}

export function getBaseUrl() {
  return process.env.BASE_URL;
}

export function isNativeAndroid() {
  return process.env.CORDOVA_PLATFORM === 'android';
}

export function isNativeIos() {
  return process.env.CORDOVA_PLATFORM === 'ios';
}
